export default __webpack_public_path__ + "static/media/python-projects.735ca0b1.jpg";